import React, { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Row, Button } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-solid-svg-icons'
import { IMainState } from 'store/states'
import SelectInput from 'components/ui/forms/field/select-input/SelectInput'
import * as fromActions from 'store/actions/participants.action'
import * as fromProfilesActions from 'store/actions/lms-profiles.action'
import { LmsProfileTypes } from 'enum/lms-profile-types.enum'
import styles from './EditProfilesModal.module.scss'

interface IEditProfilesModal {
  show: boolean
  onClose: any
  userId: number
  initialState: any
}

const EditProfilesModal: React.FC<IEditProfilesModal> = ({
  show,
  onClose,
  initialState,
  userId,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch({ type: fromProfilesActions.LMS_ALL_PROFILES_LIST })
  }, [dispatch])

  const { allProfilesList: lmsProfileList } = useSelector(
    ({ lmsProfiles }: IMainState) => lmsProfiles
  )

  const [selectedTags, setSelectedTags] = useState([])

  useEffect(() => {
    if (initialState) {
      const tags = initialState.map(
        ({ id: value, name: label, color }: any) => ({ value, label, color })
      )
      setSelectedTags(tags)
    }
  }, [initialState, show])

  const tagsLmsProfileList = useMemo(
    () =>
      (lmsProfileList || [])
        .filter(
          (lmsProfile) =>
            lmsProfile.profileType === LmsProfileTypes.participants
        )
        .map(({ id: value, name: label, color }) => ({
          value,
          label,
          color,
        })),
    [lmsProfileList]
  )

  const handleSubmit = () => {
    const profiles = selectedTags ? selectedTags.map(({ value }) => value) : []
    dispatch({
      type: fromActions.PARTICIPANT_EDIT_PROFILES,
      payload: { userId, profiles },
    })
    onClose()
  }

  return (
    <Modal show={show} onHide={onClose} className={styles.modalContainer}>
      <Modal.Body className={'mx-3 position-relative'}>
        <Row className="position-relative">
          <h1>{t('configuration.user.modal.title')}</h1>
          <a className={styles.closeButton} onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </a>
        </Row>
        <Row className="d-block mt-3">
          <SelectInput
            name="optionalProfiles"
            label={t('configuration.user.modal.userProfiles')}
            closeMenuOnSelect={true}
            options={tagsLmsProfileList}
            value={selectedTags}
            isMulti={true}
            withColors={true}
            onChange={(selected: any) => setSelectedTags(selected)}
            cleareable={false}
            error={''}
          />
        </Row>
      </Modal.Body>
      <div className="d-flex justify-content-end px-3">
        <Button variant="secondary" size="sm" onClick={onClose}>
          {t('configuration.user.modal.buttons.cancel')}
        </Button>
        <Button
          className="ml-2"
          variant="primary"
          data-testid="save-profiles"
          size="sm"
          onClick={handleSubmit}
        >
          {t('configuration.user.modal.buttons.save')}
        </Button>
      </div>
    </Modal>
  )
}

export default EditProfilesModal
